module.exports = __webpack_public_path__ + "a50dcefcddfd1140f5e7465cda832a82.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/space-vision-house.png
// module id = 597
// module chunks = 0